import { transactionsTypes } from 'app-components/flux/transactions';
import type { InvestmentTransactionTxnType } from 'app-components/forms/investment/investmentTransactionForm';
import {
  getInvestmentAmountFieldDisplay,
  type InvestmentTransactionAmountFieldLabelKey,
  VIRTUAL_CASH_FLOW_TXN_TYPE,
} from 'app-components/forms/investment/investmentTransactionFormDisplay';

export const amountLabelByKey: Record<InvestmentTransactionAmountFieldLabelKey, string> = {
  amount: 'Amount',
  amountReturned: 'Amount returned',
  distributionAmount: 'Distribution Amount',
  dividend: 'Dividend',
  interest: 'Interest',
  interestPaid: 'Interest paid',
  totalAmount: 'Total amount',
};

export const amountLabel = (
  investmentTxnType: InvestmentTransactionTxnType | null | undefined,
): { label: string; expectedSign?: 'positive' | 'negative' } => {
  const display = getInvestmentAmountFieldDisplay(investmentTxnType);
  return {
    expectedSign: display.expectedSign,
    label: amountLabelByKey[display.labelKey],
  };
};

export const tooltipText = (investmentTxnType: InvestmentTransactionTxnType | null | undefined): string => {
  switch (investmentTxnType) {
    case transactionsTypes.InvestmentTxnType.BUY:
    case transactionsTypes.InvestmentTxnType.COVER_SHORT_SELL:
      return 'Enter total price, shares, and commission. Simplifi calculates price per share.';
    case transactionsTypes.InvestmentTxnType.SELL:
    case transactionsTypes.InvestmentTxnType.SELL_BONDS:
    case transactionsTypes.InvestmentTxnType.SHORT_SELL:
      return 'Enter total sale price, shares, and commission. Simplifi calculates price per share.';
    case transactionsTypes.InvestmentTxnType.STOCK_DIVIDEND:
      return 'A dividend payment made in additional shares rather than cash.';
    case transactionsTypes.InvestmentTxnType.REINVEST_DIVIDEND:
    case transactionsTypes.InvestmentTxnType.REINVEST_INTEREST:
    case transactionsTypes.InvestmentTxnType.REINVEST_CAPITAL_GAIN_LONG:
    case transactionsTypes.InvestmentTxnType.REINVEST_CAPITAL_GAIN_SHORT:
      return 'Enter distribution amount, reinvested shares, and commission. Simplifi calculates price per share.';
    case transactionsTypes.InvestmentTxnType.ADD_SHARES:
      return 'Enter holdings without affecting cash balance.';
    case transactionsTypes.InvestmentTxnType.REMOVE_SHARES:
      return 'Remove shares without affecting cash balance.';
    case transactionsTypes.InvestmentTxnType.STOCK_SPLIT:
      return 'Record a corporate action that divides or multiplies existing shares.';
    case VIRTUAL_CASH_FLOW_TXN_TYPE:
      return 'Cash flow transaction';
    case transactionsTypes.InvestmentTxnType.UNKNOWN:
      return 'Please select valid type';
    default:
      return '';
  }
};
